import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../hooks/hooks';
import { selectprogramsListItems} from '../../redux/programs/selector';
import { programs } from '../../redux/programs/action';
import { subscriptions } from '../../redux/subscriptions/action';
import PageLoader from '../../components/PageLoader';
import EnableNPSubscriptionComponent from './subscription.component';

const ManagementSubscription = () => {
      const navigate = useNavigate()
      const dispatch = useAppDispatch()
      const [isLoading, setIsLoading] = useState<boolean>(true)
      const programItems = useSelector(selectprogramsListItems);
  const [
    enableSubscription,
    setEnableSubscription
  ] = useState<any>({})

  const handleInnerFormChange: any = (event: any, field: string) => {
    if (field === 'OwnerId') {
      setEnableSubscription({ ...enableSubscription, [field]: event });
    } else {
      setEnableSubscription({ ...enableSubscription, [field]: event });
    }
  }

  useEffect(
    () => {
      dispatch(
           programs.list({
             url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,
             entity: 'programs',
             jsonData: {},
           })
         )
        setIsLoading(false)
    },
    []
  )
 
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
      await dispatch(subscriptions.create({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/np-subscriptions`, entity: 'subscriptions', jsonData: {

          "Context": null,
          Records: [{
            "OwnerType": 'DBaaSProgram',
            "OwnerId": enableSubscription?.OwnerId,
        }]
        }
      }))
    back()
  }

  const back=()=>{
    navigate('/management/subscriptions')
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <EnableNPSubscriptionComponent
          programs={programItems?.result?.items}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          enableSubscription={enableSubscription}
        />
      }
    </>
  )

}

export default ManagementSubscription;